"use strict";
ui.loadTemplateFile("minimap.html");

import {
    minimapBoundsToWorld,
    minimapImagePath,
    worldToMapImage,
} from "../../js/maps/mapcoordinates";
import { NpcObject } from "../../js/objects/npcobject";

const MINIMAP_SIZE = 180;
const MINIMAP_IMAGE_SIZE = 270;

class MinimapDialog extends Dialog {
    _element: any;
    _currentZone: any;
    _zoneTable: any;
    _imageWidth: number;
    _imageHeight: number;
    _movementHandler: any;
    _objectHandler: any;

    constructor() {
        super("minimap.html");
        this._currentZone = null;
        this._zoneTable = null;
        this._imageWidth = 0;
        this._imageHeight = 0;
        this._movementHandler = () => this._updateMinimap();
        this._objectHandler = () => this._renderMarkers();

        GDM.get("list_zone", (zoneTable: any) => {
            this._zoneTable = zoneTable;
            this._updateMinimap();
        });

        if (MC) {
            MC.on("moved", this._movementHandler);
        }
        if (GZM.objects) {
            GZM.objects.on("object_added", this._objectHandler);
            GZM.objects.on("object_removed", this._objectHandler);
        }
    }

    _updateMinimap() {
        if (!this._zoneTable || !MC || MC.zoneNo === undefined) return;

        if (MC.zoneNo !== this._currentZone) {
            this._currentZone = MC.zoneNo;
            this._imageWidth = 0;
            this._imageHeight = 0;

            const mapRow = this._mapRow(MC.zoneNo);
            if (!mapRow) return;

            const imgElement = this._element.find("#minimap-image");
            const onImageLoad = () => {
                this._imageWidth = imgElement[0].naturalWidth;
                this._imageHeight = imgElement[0].naturalHeight;
                this._renderMarkers();
            };
            imgElement.off("load").on("load", onImageLoad);
            imgElement.attr("src", minimapImagePath(mapRow[8]));
            if (imgElement[0].complete && imgElement[0].naturalWidth > 0) {
                onImageLoad();
            }
            return;
        }

        this._renderMarkers();
    }

    _renderMarkers() {
        if (!this._zoneTable || !MC || !MC.position || !this._imageWidth) return;

        const mapRow = this._mapRow(MC.zoneNo);
        if (!mapRow) return;

        const worldBounds = minimapBoundsToWorld(
            Number(mapRow[9]), Number(mapRow[10]), this._imageWidth, this._imageHeight
        );
        const scaleX = MINIMAP_IMAGE_SIZE / this._imageWidth;
        const scaleY = MINIMAP_IMAGE_SIZE / this._imageHeight;
        const playerPoint = worldToMapImage(
            MC.position.x,
            MC.position.y,
            worldBounds,
            this._imageWidth,
            this._imageHeight
        );
        const imageLeft = MINIMAP_SIZE / 2 - playerPoint.x * scaleX;
        const imageTop = MINIMAP_SIZE / 2 - playerPoint.y * scaleY;

        this._element.find("#minimap-image").css({
            left: imageLeft + "px",
            top: imageTop + "px",
            width: MINIMAP_IMAGE_SIZE + "px",
            height: MINIMAP_IMAGE_SIZE + "px",
        });

        const markers = this._element.find("#minimap-markers").empty();
        if (!GZM.objects || !GZM.objects.objects) return;

        GZM.objects.objects
            .filter((obj: any) => obj instanceof NpcObject)
            .forEach((npc: any) => {
                if (!npc.position) return;
                const point = worldToMapImage(
                    npc.position.x,
                    npc.position.y,
                    worldBounds,
                    this._imageWidth,
                    this._imageHeight
                );
                if (!point.inside) return;

                const x = imageLeft + point.x * scaleX;
                const y = imageTop + point.y * scaleY;
                const center = MINIMAP_SIZE / 2;
                const visibleRadius = center - 5;
                if ((x - center) ** 2 + (y - center) ** 2 > visibleRadius ** 2) return;

                $("<div>")
                    .addClass("minimap-npc-marker")
                    .attr("title", npc.name || `NPC #${npc.charIdx}`)
                    .css({ left: x - 3 + "px", top: y - 3 + "px" })
                    .appendTo(markers);
            });
    }

    _mapRow(mapId: number) {
        const compiled = GZM.map?.compiledTerrain;
        if (compiled?.mapId === mapId && compiled.gameplay.settings.minimap) {
            const settings = compiled.gameplay.settings;
            const row: any[] = [];
            row[8] = settings.minimap;
            row[9] = settings.minimapStartX;
            row[10] = settings.minimapStartY;
            return row;
        }
        return this._zoneTable?.row(mapId);
    }

    close() {
        if (MC && this._movementHandler) {
            MC.removeEventListener("moved", this._movementHandler);
        }
        if (GZM.objects && this._objectHandler) {
            GZM.objects.removeEventListener("object_added", this._objectHandler);
            GZM.objects.removeEventListener("object_removed", this._objectHandler);
        }
        super.close();
    }
}

ui.MinimapDialog = MinimapDialog;
ui.minimapDialog = function () {
    return new ui.MinimapDialog();
};
